<template>
  <w-dialog :show="show"
            show-close
            box-style="width: 587px;"
            title="修改人材机"
            :wallStyle="{zIndex: 1009}"
            footer-style="padding-bottom: 24px;border-top: 0;"
            @close="cancelHandle">
    <div class="dialog-body--database__edit">
      <table class="ui-table revise-table" width="100%" cellspacing="0" cellpadding="0">
        <tbody>
        <tr>
          <td class="font-center ui-w60">名称</td>
          <td>
            <!--<textarea class="ui-textarea dialog-width name-height"-->
                      <!--v-model="formData.description">-->
            <!--</textarea>-->
            <w-input
              type="textarea"
              rows="3"
              placeholder="请输入..."
              v-model="formData.description"
            ></w-input>
          </td>
        </tr>
        <tr>
          <td class="font-center ui-w60">规格型号</td>
          <td>
            <!--<textarea class="ui-textarea dialog-width spec-height"-->
                      <!--v-model="formData.spec">-->
            <!--</textarea>-->
            <w-input
              type="textarea"
              rows="3"
              placeholder="请输入..."
              v-model="formData.spec"
            ></w-input>
          </td>
        </tr>
        <tr>
          <td class="font-center ui-w60">单位</td>
          <td>
            <div class="text-select dialog-width">
              <w-select size="small" v-model="formData.unit">
                <w-option value="m">m</w-option>
                <w-option value="m2">m2</w-option>
                <w-option value="m3">m3</w-option>
                <w-option value="台班">台班</w-option>
                <w-option value="工日">工日</w-option>
                <w-option value="t">t</w-option>
                <w-option value="kg">kg</w-option>
                <w-option value="座">座</w-option>
                <w-option value="组">组</w-option>
                <w-option value="宗">宗</w-option>
                <w-option value="元">元</w-option>
                <w-option value="套">套</w-option>
                <w-option value="台">台</w-option>
                <w-option value="千米">千米</w-option>
                <w-option value="千克">千克</w-option>
                <w-option value="辆">辆</w-option>
                <w-option value="块">块</w-option>
                <w-option value="公斤">公斤</w-option>
                <w-option value="付">付</w-option>
                <w-option value="处">处</w-option>
                <w-option value="部">部</w-option>
                <w-option value="10t">10t</w-option>
                <w-option value="10m2">10m2</w-option>
                <w-option value="10m3">10m3</w-option>
                <w-option value="10m">10m</w-option>
                <w-option value="100m2">100m2</w-option>
                <w-option value="100m3">100m3</w-option>
                <w-option value="100m">100m</w-option>
                <w-option value="1000块">1000块</w-option>
                <w-option value="立方米">立方米</w-option>
                <w-option value="平方米">平方米</w-option>
                <w-option value="株">株</w-option>
              </w-select>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <template slot="footer">
      <w-button type="primary" size="small" @click="submitHandle">确认</w-button>
      <w-button size="small"  @click="cancelHandle">取消</w-button>
    </template>
  </w-dialog>
</template>
<script>
import databaseEditMixin from '@/assets/mixins/database-edit'
export default {
  name: 'DialogEditMaterial',
  mixins: [databaseEditMixin],
  data () {
    return {
      pageType: 'material'
    }
  }
}
</script>
<style lang="less" type="text/less">
  .ui-table td {
    padding: 5px 6px;
    color: #333;
    font-size: 12px;
    border-bottom: 1px solid #ccc;
  }

  .ui-table tbody tr {
    height: 46px;
  }

  .ui-table tr:hover td {
    background-color: #E6F9FF
  }

  .text-select{
    position: relative;
  }

  .text-select select {
    position: absolute;
    top: -15px;
    left: 0;
  }
  .dialog-body--database__edit{
    .ui-textarea {
      border: 1px solid #ccc;
      line-height: 28px;
      background-color: #fff;
      font-size: 12px;
      color: #666;
      padding: 0 5px;
      display: inline-block;
      vertical-align: middle;
    }
    textarea {
      resize: vertical;
      overflow: auto;
      vertical-align: top;
    }
    select {
      border: 1px solid #ccc;
      color: #666
    }

    select:hover,select:focus {
      border-color: #A8C4E3;
      outline: 0
    }
    .revise-table{
       border: 1px solid #ccc;
     }
    .text-select select{
      height: 30px;
      line-height: 30px;
    }
    .dialog-width{
      width: 461px;
    }
    .name-height{
      height: 84px;
    }
    .spec-height{
      height: 140px;
    }
    .ui-table tbody td {
      border-bottom: none
    }
    .ui-table tbody tr+tr td {
      border-top: 1px solid #ccc
    }
    .text-select select {
      height: 30px;
      line-height: 30px;
    }
  }
</style>
